BaseManager = require 'BaseManager'
eventManager = require 'eventManager'
log = require 'loglevel'

###############################################

class DeviceManager extends BaseManager

  name: 'DeviceManager'
  triedFullscreen: false
  resizeThrottling: 40

  # -------------------------------------------

  constructor: ->
    log.info @name, 'constructor'

    window.__dpi = @getDpi()
    window.__isHttps = @isHttps()
    window.__isTouch = @isTouchscreen()

    @_pageVisibility()
    @_resize()

  # -------------------------------------------

  isHttps: ->
    return window.location.protocol is "https:"

  # -------------------------------------------

  isInIframe: ->
    self isnt top

  # -------------------------------------------

  whichIE: ->
    myNav = navigator.userAgent.toLowerCase()
    if myNav.indexOf('msie') != -1 then parseInt(myNav.split('msie')[1]) else false

  # -------------------------------------------

  isWebkit: ->
    isWebkit = /WebKit/.test(navigator.userAgent)
    isWebkit

  # -------------------------------------------

  isIOS: ->
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    iOS

  # -------------------------------------------

  isTouchscreen: ->
    'ontouchstart' of window or navigator.MaxTouchPoints > 0 or navigator.msMaxTouchPoints > 0

  # -------------------------------------------

  isRetina: ->
    @getDpi() > 1

  # -------------------------------------------

  getDpi: ->
    vp = @getViewport()
    if vp.w > 900 or vp.h > 518
      return 2

    dpi = Math.floor window.devicePixelRatio
    return 2 if dpi > 2
    dpi

  # -------------------------------------------

  isLandscape: ->
    v = @getViewport()

    w = v.w
    h = v.h
    isLandscape = false
    if w > h
      isLandscape = true
    isLandscape

  # -------------------------------------------

  getViewport: ->
    vp =
      w: Math.floor(document.documentElement.clientWidth, window.innerWidth || 0)
      h: Math.floor(document.documentElement.clientHeight, window.innerHeight || 0)
    vp

  # -------------------------------------------

  getWrapperDimensions: ->
    wrapper = document.getElementById('wrapper')

    vp = @getViewport()

    wd =
      w: vp.w - 20
      h: vp.h - 20
    wd

  # -------------------------------------------

  viewportSize: ->
    test = document.createElement( "div" )

    test.style.cssText = "position: fixed;top: 0;left: 0;bottom: 0;right: 0;"
    document.documentElement.insertBefore( test, document.documentElement.firstChild )

    dims = { width: test.offsetWidth, height: test.offsetHeight }
    document.documentElement.removeChild( test )

    dims

  # -------------------------------------------

  _resize: ->

    triggerResize = =>
      lazyLayout = UTIL.debounce ( =>
        eventManager.trigger 'page-resize'
      ), @resizeThrottling
      lazyLayout()

    window.addEventListener 'resize', triggerResize
    # window.onorientationchange = triggerResize

  # -------------------------------------------

  _pageVisibility: ->
    hidden = undefined
    visibilityChange = undefined
    # If the page is hidden, pause the video;
    # if the page is shown, play the video

    handleVisibilityChange = ->
      if document[hidden]
        eventManager.trigger 'page-hide'

      else
        eventManager.trigger 'page-show'

    if typeof document.hidden != 'undefined'
      # Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden'
      visibilityChange = 'visibilitychange'

    else if typeof document.mozHidden != 'undefined'
      hidden = 'mozHidden'
      visibilityChange = 'mozvisibilitychange'

    else if typeof document.msHidden != 'undefined'
      hidden = 'msHidden'
      visibilityChange = 'msvisibilitychange'

    else if typeof document.webkitHidden != 'undefined'
      hidden = 'webkitHidden'
      visibilityChange = 'webkitvisibilitychange'

      # Handle page visibility change
    document.addEventListener visibilityChange, handleVisibilityChange, false

  # -------------------------------------------

module.exports = DeviceManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/device-manager.coffee